import src from "IMAGE";
export default { src, width: 383, height: 383, blurWidth: 0, blurHeight: 0};
